module.exports = __webpack_public_path__ + "img/linkedin.f54e1d68.svg";